"use client";

import { createContext, useContext } from "react";

/**
 * The theme
 * @typedef {object} ThemeConfigContextValue
 * @prop {import("@chakra-ui/react").ButtonProps} buttonProps
 * @prop {import("@chakra-ui/react").InputProps} inputProps
 * @prop {import("@chakra-ui/react").NativeSelectFieldProps} nativeSelectProps
 * @prop {Omit<import("@chakra-ui/react").DialogRootProps, "children">} dialogRootProps
 * @prop {Omit<import("@chakra-ui/react").DialogHeaderProps, "children">} dialogHeaderProps
 * @prop {import("@chakra-ui/react").DialogFooterProps} dialogFooterProps
 * @prop {import("@chakra-ui/react").TextareaProps} textareaProps
 * @prop {import("@chakra-ui/react").CheckboxRootProps} checkboxProps
 * @prop {import("@chakra-ui/react").TagRootProps} tagProps
 * @prop {import("../components/ui/icon-button").IconButtonProps} iconButtonProps
 * @prop {import("@chakra-ui/react").SelectTriggerProps} selectTriggerProps
 */

/** @type {ThemeConfigContextValue} */
const DEFAULT_VALUES = {
  buttonProps: {},
  inputProps: {},
  nativeSelectProps: {},
  dialogRootProps: {},
  dialogHeaderProps: {},
  dialogFooterProps: {},
  textareaProps: {},
  checkboxProps: {},
  tagProps: {},
  iconButtonProps: {},
  selectTriggerProps: {},
};

const ThemeConfigContext = createContext(DEFAULT_VALUES);

export function useThemeConfig() {
  const value = useContext(ThemeConfigContext);

  return value;
}

/**
 * @typedef {object} Props
 * @prop {ThemeConfigContextValue} config
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function ThemConfigProvider({ config, children }) {
  return (
    <ThemeConfigContext.Provider value={config}>
      {children}
    </ThemeConfigContext.Provider>
  );
}
